import React from "react";
import { styled } from "styled-components";
import { SvgProps } from "../types";

const BrandText = styled.span`
  margin-left: 12px;
  font-family: "Inter", system-ui, -apple-system, sans-serif;
  font-weight: 600;
  font-size: 30px;
  color: currentColor;
  white-space: nowrap;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  const { width, height, color, spin, theme, style, ...rest } = props;
  const imgSize = parseInt(height ?? "48px", 10);
  return (
    <Wrapper style={{ width, height, color, ...style }} {...rest}>
      <img
        src="/images/logo_white_bg.png"
        alt="Machain"
        width={imgSize}
        height={imgSize}
        style={{ objectFit: "contain", display: "block" }}
      />
      <BrandText>Machain</BrandText>
    </Wrapper>
  );
};

export default Icon;
